import { defineStore } from "pinia";
import { shipping_address_inputs_structure_data, basic_information_inputs_structure_data, getCountryCode, getCountryNameViaCountryCode } from '@/components/shippingAddress/shippingAddressData/shippingAddressInputsStructure.js';
import  { baseURL, inventoryBaseURL, coreServiceBaseURL, sampleBaseURL}  from "@/components/bloodDraw/BloodDrawData/request";
import { ElNotification } from "element-plus";
import { checkWhetherOrderHasTag, isNewYorkState, getFullStateName } from "@/utils/commonActions.js";
import { country_code_to_area_code_map } from "@/components/bloodDraw/BloodDrawData/AreaCodeMap.js";

import gql from "graphql-tag";
import { pns_graphal_client } from "@/utils/graphQLRequests.js";
// import { addBusinessDays } from "@/components/shippingAddress/shippingAddressData/dateFunctions";
// import moment from "moment";
// import router from "@/routes";


export const useShippingAddressStore = defineStore('ShippingAddressStore',{
    state:()=>{
        return{
            loading:false,
            // *********************************************  query params  *********************************************
            // --------------- order info and auth params ----------------
            accession_id:null,
            sample_id:null,
            token:null,
            // --------------- order info and auth params ----------------
            count:null,
            from_source:null, // might be "email", no value or other ENUMs in the future
            // ********************************************* query params Ends  *********************************************

            patient_id:null,
            order_id:null,
            customer_id:null,

            order_source:null,
            address_needed:null,
            // VIB-1735: order tags from backend; contains "GZ" (Gut Zoomer) or "GZ_NY" (NY version).
            order_tag_list:null,
            // VIB-1735: GZ/GZ-NY address-change block popup (PRD §4.1 / §4.2).
            show_gz_ny_block_dialog:false,
            gz_ny_block_direction:null, // 'non_ny_to_ny' (§4.1) | 'ny_to_non_ny' (§4.2)
            gz_ny_block_patient_state:null, // full state name interpolated into the §4.2 copy
            is_family_order:false,
            is_family_main_order:false,

            // ************************** for Basic and Shipping Information Inputs View **************************
            // ########## used for inputs structure and required validation ###########
            //the basic information inputs structure data
            basic_information_inputs_structure_data,
            //the shipping address inputs structure data
            shipping_address_inputs_structure_data,
            country_list:[],
            required_input_fields:{},
            invalid_input_values:{
                // eg.
                // 'basic_info_section':{},
                // 'shipping_address_section':{}
            },
            // NOTES: required_input_fields is used to store the number of required input fields
            //       for example: if there is a required input field named 'gender', then the required_input_fields['gender'] will be 1
            // ########## used for inputs structure and required validation ENDS ###########

            // ########## data from backend used for inputs prefills and edits ###########
            previous_shipping_address_data:{},
            current_shipping_address_data:{},
            is_confirmed_or_saved_before: false,
            is_address_change_significant_before_confirmed:null,
            is_editable:true,
            // ########## data from backend used for inputs prefills and edits ENDS ###########

            // ########## data and validaton checks on page, and others ###########
            patient_profile_address:{},

            
            edits_saved:false,
            is_apply_to_future_order:false,
            incomplete_address_in_db:null,
            incomplete_basic_information_in_db:null,
            is_current_shipping_address_same_with_patient_profile_address:false,
            //for confirm information loading 
            confirm_info_loading:false,
            // ########## data and validaton checks on page, and others ENDS ###########
            // ************************** for Basic and Shipping Information Inputs View ENDS **************************

            // ************************** for checking duplicate patient **************************
            //for contact support page due to potential duplicated patient
            show_contact_support_to_solve_duplicated_patient:false,
            //for duplicated patient dialog
            potential_duplicated_patient:null,
            //whether user has already done the merge patient operation
            merged_patient:false,
            // ************************** for checking duplicate patient ENDS **************************

            // ************************** for next step **************************
            need_blood_draw:null,
            is_kit_delivered:null,
            // whether the (legacy, sunset on 09/01/2026) concierge blood draw fee was already paid on this order
            is_concierge_paid:false,

        }
    },
    getters:{
        // VIB-1735: standard Gut Zoomer (incl. Stool Only) order — backend tags it "GZ".
        is_gz_order(state){
            return checkWhetherOrderHasTag(state.order_tag_list, 'GZ');
        },
        // VIB-1735: Gut Zoomer New York order — backend tags it "GZ_NY".
        is_gz_ny_order(state){
            return checkWhetherOrderHasTag(state.order_tag_list, 'GZ_NY');
        },
    },

    actions:{
        storeAllQueryInfomation(query){
            // if has query params: store all query params
            // NOTES: no need to store flow type params, as Information page's redirect logic is always considered as Regular Flow
            if(query){
                console.log('has query params');
                this.accession_id = query.accession_id;
                this.sample_id = query.sample_id;
                this.token = query.token;
                this.count = query.count;
                this.from_source = query.from;
            }else{
                console.log('no query params');
                // if no query params: reject error
                throw new Error('No query params');
            }
        },
        goToNextStep(router){
            // Information page will only redirect to Payment page, always considered as Regular Flow.
            // No need to pass any flow type params in the query
            router.push({
                name: "paymentMedia",
                query: {
                    accession_id: this.accession_id,
                    sample_id: this.sample_id,
                    token: this.token,
                    ...(this.count != null ? { count: this.count } : {}),
                    ...(this.from_source != null ? { from: this.from_source } : {}),
                }
            });
        },
        async initiateBasicAndShippingInfoPage(){
            // 1. get accession_id, sample_id, order_id, customer_id, patient_id, order_source, bloodKitDeliveryMethod, and nonBloodKitDeliveryMethod via graphQL
            // NOTES: get PNS related data need to use all ids. order_source will decide whether the page is display-only.
            try{
                // 1.1 call graphQL api to get orderV2 related data
                const all_ids_and_order_source = await this.getAllIdsAndOrderRelatedDataViaSampleId(this.sample_id);
                // 1.2 assign order_id, customer_id, patient_id, order_source, as accession_id and sample_id are normally already gotten from URL params.
                this.patient_id = all_ids_and_order_source?.patientId;
                this.customer_id = all_ids_and_order_source?.customerId;
                this.order_id = all_ids_and_order_source?.orderIdStr;
                this.order_source = all_ids_and_order_source?.order_source;
                // 1.3 assign is_concierge_paid, need_blood_draw, and address_needed
                this.is_concierge_paid = all_ids_and_order_source?.is_concierge_paid;
                this.address_needed = all_ids_and_order_source?.bloodKitDeliveryMethod == 'shipToPatient' || all_ids_and_order_source?.nonBloodKitDeliveryMethod == 'shipToPatient';
                this.need_blood_draw = all_ids_and_order_source?.bloodKitDeliveryMethod != null;
                //1.4 assign orderTagList (VIB-1735: signals GZ vs GZ-NY order)
                this.order_tag_list = all_ids_and_order_source?.orderTagList;
                // 1.5 assign is_family_order, is_family_main_order, and all_sample_ids_if_family_order
                this.is_family_order = all_ids_and_order_source?.isFamilyOrder;
                this.is_family_main_order = all_ids_and_order_source?.isFamilyMainOrder;
            
                // 2. get data needed for intiating basic and shipping info page via graphQL
                const basicAndShippingInfoPageData = await this.getBasicAndShippingInfoPageData(this.accession_id, this.sample_id, this.order_id, this.patient_id, this.customer_id);
                this.country_list = basicAndShippingInfoPageData?.countryList ?? [];
                //  2.1 assign page-initiation-requried data 
                //      2.1.1 assign data related Basic Information And Shipping Address Info 
                await this.setBasicInformationAndShippingAddressInfoRelatedData(basicAndShippingInfoPageData?.confirmAddress?.data);
                //      2.1.2 assign is_confirmed_or_saved_before
                await this.isShippingAddressConfirmedOrSavedBefore(basicAndShippingInfoPageData?.checkAddressConfirmation?.data, this.sample_id)
                //      2.1.3 assign patient_address (patient-level)
                this.patient_profile_address = basicAndShippingInfoPageData?.patientInfo?.patient_address?.[0];
               
            }catch(err){
                console.log('initiateBasicAndShippingInfoPage Error', err);
                throw new Error(err?.message ?? 'Failed to initiate Information Page.');
            }
        },
        //graphQL requests
        async getAllIdsAndOrderRelatedDataViaSampleId(sample_id){
            const GET_ALL_IDs_AND_ORDER_SOURCE_VIA_SAMPLE = gql `
                query getAllIdsAndOrderRelatedDataViaSampleId( $sampleIdList:[String!] ){
                    patientOrder(orderInput:{ sampleIdList: $sampleIdList }){
                        orders{
                            order{
                                patientId
                                orderIdStr
                                customerId
                                julienBarcode
                                sampleId
                                order_source
                                orderTagList
                                is_concierge_paid
                                bloodKitDeliveryMethod
                                nonBloodKitDeliveryMethod
                                orderItems {
                                    item_id
                                    item_type
                                    x_choose_y_List {
                                        x_choose_y_detail_list {
                                            item_id
                                            item_type
                                        }
                                    }
                                }
                                isFamilyOrder
                                isFamilyMainOrder
                            }
                        }
                    }
                }
            `;
            try{
                const { data, errors } = await pns_graphal_client.query({
                    query: GET_ALL_IDs_AND_ORDER_SOURCE_VIA_SAMPLE,
                    variables: {
                        sampleIdList: [sample_id]
                    },
                    context:{
                        headers:{
                            Authorization: `Bearer ${ this.token ? this.token : localStorage.getItem('pnsToken')}`
                        }
                    }
                });
                //As graphql won't trhow an error automatically, we need to manually check the error.
                if(errors && errors.length > 0){
                    throw new Error(errors.map(err => err.message).join(' | '));
                }
                return Promise.resolve(data?.patientOrder?.orders?.[0]?.order);
            }catch(err){
                console.log('getAllIdsAndOrderRelatedDataViaSampleId err', err);
                throw new Error(err?.message ?? 'Failed to get ids and order source.');
            }
        },
        async getBasicAndShippingInfoPageData(accession_id, sample_id, order_id, patient_id, customer_id) {
            const GET_BASIC_AND_SHIPPING_INFO_PAGE_DATA = gql `
                query getBasicAndShippingInfoPageData( $accession_id: String!, $sample_id: String!, $order_id: String!, $patient_id: String!, $customer_id:String ){
                    patientPNS(PNSInput: { accession_id: $accession_id, sample_id: $sample_id, order_id: $order_id, patient_id: $patient_id, customer_id:$customer_id }){
                        patientInfo {
                            patient_address {
                                street_address
                                apt_po
                                city
                                state
                                zipcode
                                country
                                address_type
                            }
                        }
                        confirmAddress {
                            data {
                                is_editable
                                reason
                                name
                                street
                                apt_po
                                city
                                state
                                zipcode
                                country
                                gender
                                birthdate
                                phone
                            }
                        }
                        checkAddressConfirmation {
                            data {
                                address_confirmed_samples
                                address_not_confirmed_samples
                                address_verified_by_patient_samples
                            }
                        }
                        countryList {
                            vibrantCountryId
                            countryName
                            countryNameTwoBytes
                        }
                    }
                }
            `;
            try{
                const { data, errors } = await pns_graphal_client.query(
                    {
                        query: GET_BASIC_AND_SHIPPING_INFO_PAGE_DATA,
                        variables:{
                            accession_id: String(accession_id),   
                            sample_id: String(sample_id),
                            order_id: String(order_id),
                            patient_id: String(patient_id),
                            customer_id: String(customer_id)
                        },
                        context:{
                            headers:{
                                Authorization: `Bearer ${this.token ? this.token : localStorage.getItem('pnsToken')}`
                            }
                        }
                    }
                )
                //As graphql won't trhow an error automatically, we need to manually check the error.
                if(errors && errors.length > 0){
                    throw new Error(errors.map(err => err.message).join(' | '));
                }
                return Promise.resolve(data?.patientPNS);
            }catch(err){
                console.log('getBasicAndShippingInfoPageData error', err);
                throw new Error( err?.message ?? 'Failed to get basic and shipping info page data.');
            }
        },
        setBasicInformationAndShippingAddressInfoRelatedData(data){
            console.log('set Basic Information And Shipping Address Info');
            try{
                // parse phone number
                const phone_number_object = this.parseBackendPhoneNumberStringToPhoneObject(data.phone);
                const parsed_data = JSON.parse(JSON.stringify(data));
                parsed_data.phone = phone_number_object;
                // VIB-1775: `apt_po` may come back as null; normalize to '' so the input binds cleanly and
                // extractChangedInputs() only reports a change when the user actually edits the unit.
                parsed_data.apt_po = parsed_data.apt_po ?? '';
                this.previous_shipping_address_data = JSON.parse(JSON.stringify(parsed_data));
                this.current_shipping_address_data = JSON.parse(JSON.stringify(parsed_data));
                // 1. check is incomplete address and incomplete basic information in DB
                this.incomplete_address_in_db = !this.previous_shipping_address_data.street || !this.previous_shipping_address_data.city || !this.previous_shipping_address_data.state || !this.previous_shipping_address_data.zipcode || !this.previous_shipping_address_data.country;
                this.incomplete_basic_information_in_db = !this.previous_shipping_address_data.country || this.previous_shipping_address_data.country == "US"
                ?
                !this.previous_shipping_address_data.gender || !this.previous_shipping_address_data.birthdate
                :
                !this.previous_shipping_address_data.gender || !this.previous_shipping_address_data.birthdate || !this.previous_shipping_address_data.phone
                ;
                // 2. check country field of data to assign country input's dropdown options
                for(const input_unit_info of this.shipping_address_inputs_structure_data){
                    if(input_unit_info.input_id == "country"){
                        //  2.1 if country is empty or is one of the free-shipping countries ("US" or "CA"):
                        //     -> only show 'US' and 'CA' as the option to limit the delivery range to avoid not paying delivery fee for international delivery
                        //     -> set the autofilled input's customized_props's search_range to be "US" (customized_props has all props except for value that the customized unit component has)
                        if(!this.previous_shipping_address_data.country 
                        || this.previous_shipping_address_data.country.toUpperCase() == "US"
                        || this.previous_shipping_address_data.country.toUpperCase() == "CA"){
                            input_unit_info.dropdown_options = [
                                {
                                    label: 'United States (US)',
                                    value: 'US'
                                },
                                {
                                    label: 'Canada (CA)',
                                    value: 'CA'
                                }
                            ];
                            //find autofilled input info in shipping_address_inputs_structure_data and set its search_range
                            for(const input_unit_info of this.shipping_address_inputs_structure_data){
                                if(input_unit_info.input_id == 'street'){
                                    input_unit_info.customized_props={
                                        search_range:['US', 'CA'],
                                    };
                                    break;
                                }
                            }  
                        }else{
                        //  2.2 if country has NON-US and NON-CA value:
                        //     -> 2.2.1 if current country value can be matched with country code and country name:
                        //          -> only show 'US', 'CA', and current country value as the option to limit the delivery range to avoid not paying delivery fee for other international delivery
                        //     -> 2.2.2 if current country value's matched country name is empty:
                        //          -> show 'US', 'CA', and current unmatched country value 
                        //     -> 2.2.3 set the autofilled input's customized_props's search_range to be the corresponding country code (all lower cases, cleaning and match non-country code data via countries.js)
                            const current_country_code = getCountryCode(this.previous_shipping_address_data.country);
                            const current_country_name = getCountryNameViaCountryCode(current_country_code);
                            var current_search_range;
                            input_unit_info.dropdown_options = [
                                {
                                    label: 'United States (US)',
                                    value: 'US'
                                },
                                {
                                    label: 'Canada (CA)',
                                    value: 'CA'
                                },
                                current_country_name ? {
                                    label: `${current_country_name} (${current_country_code})`,
                                    value: current_country_code
                                }:{
                                    label: current_country_code,
                                    value: current_country_code
                                }
                            ];    
                            // input_unit_info.disabled = false; 
                            current_search_range = ['US','CA', current_country_code];
                            
                            //find autofilled input info in shipping_address_inputs_structure_data and set its search_range
                            for(const input_unit_info of this.shipping_address_inputs_structure_data){
                                if(input_unit_info.input_id == 'street'){
                                    input_unit_info.customized_props = {
                                        search_range: current_search_range
                                    };
                                    break;
                                }
                            }
                        }
                    }
                }
                
                //3. check editable
                this.is_editable = parsed_data.is_editable;
                //4. check kit status for different status view page
                this.is_kit_delivered = parsed_data.reason == 'DELIVERED';
                //5. end the loading
                this.loading = false;
            }catch(err){
                console.log("setBasicInformationAndShippingAddressInfoRelatedData error:", err);
                this.loading = false;
                throw new Error('Set basic information and shipping address related data error.'); //to get error message: err.response.data.message
            }
        },
        isShippingAddressConfirmedOrSavedBefore(data, sample_id){
        // check whether current sample's shippingn address is confirmed or saved before
            try{
                if(data && data.address_confirmed_samples.includes(sample_id)){
                    this.is_confirmed_or_saved_before = true;
                }else{
                    this.is_confirmed_or_saved_before = false;
                }
            }catch(err){
                console.log('isShippingAddressConfirmedOrSavedBefore error:', err);
                this.is_confirmed_or_saved_before = false;
                throw new Error(err?.response?.data?.message ?? "Set whether information is confirmed before error."); //to get error message: err.response.data.message
            }
        },
        parseBackendPhoneNumberStringToPhoneObject(phone_number){
            // phone_number: String
            var parsed_phone_number={
                area_code:'',
                phone_number:'',
            }
            //parse to figure out area_code and phone_number
            // 1. Remove parentheses
            const phone_without_parentheses = phone_number.replace(/[()]/g, '');
            // 2. check if phone from backend in the format: 
            //      1) Start with an optional '+'. 
            //      2) Followed by all digits, up to a maximum length of 3
            //      3) Followed by either a - or a space (non-capturing group, the separator is matched, but not captured in the result)
            //      4) Followed by more all digits
            const check_phone_format_regex = /^\+?(\d{1,3})(?:[-\s](\d+))$/;
            const match_the_format = phone_without_parentheses.match(check_phone_format_regex);
            // 3. if the format is matched:
            if(match_the_format){
                const area_code = match_the_format[1];
                const phone_number = match_the_format[2];
                //3.1 if find area_code in country_code_to_area_code_map
                if(Object.values(country_code_to_area_code_map).includes(area_code)){
                    // 3.1.1 assign the area_code and phone_number accordingly
                    parsed_phone_number = {
                        area_code: area_code,
                        phone_number: phone_number,
                    };
                }else{
                //3.2 if cannot find area_code in country_code_to_area_code_map:
                    // 3.2.1 assign the area_code with empty string and phone_number accordingly
                    parsed_phone_number = {
                        area_code: '',
                        phone_number: phone_number,
                    };
                }
            }else{
            //if the format isn't matched:
                // 1. Remove spaces, dashes, and parentheses for consistency
                const cleaned_phone = phone_number.replace(/[\s-()]/g, '');
                parsed_phone_number = {
                    area_code:'',
                    phone_number:cleaned_phone,
                };
                if(cleaned_phone){
                    //if begin with 1, 1-, or +1:
                    const start_with_US_area_code = /^(\+1|1-?|1)/.test(cleaned_phone);
                    if(start_with_US_area_code){
                        // strip the beginning part if it starts with +1, 1-, or 1
                        const part_left = cleaned_phone.replace(/^(\+1|1-?|1)/, '');
                        //if the part_left is a 10 digits only string:
                        if(part_left.length == 10 && /^\d+$/.test(part_left)){
                            // consider as US phone: area_code:"1", phone_number:the last 10 digits
                            parsed_phone_number = {
                                area_code:'1',
                                phone_number: part_left,
                            }
                        }
                    }
                    //else: area_code:"", phone_number: cleaned phone_number
                }
            }
            return parsed_phone_number;
        },
        // apis requrests
        async getDuplicatedPatient(){
            console.log('getDuplicatedPatient in backend...');
            try{
                //first_name and last_name won't be null or undefined
                const [first_name, last_name] = this.current_shipping_address_data.name.split(' ', 2);
                if(first_name && last_name){
                    const params ={
                        sample_id: this.sample_id,
                        first_name: first_name,
                        last_name: last_name,
                        birthdate: this.current_shipping_address_data.birthdate,
                        gender: this.current_shipping_address_data.gender,
                    };
                    this.confirm_info_loading = true;
                    const res = await sampleBaseURL.post('/patients/duplicate-check',
                        params,
                        {
                            headers:{ 
                                Authorization: `Bearer ${this.token}`
                            },
                        }
                    );
                    if(res.data.has_duplicate){
                        this.potential_duplicated_patient = res.data.duplicate_patient;
                    }else{
                        this.potential_duplicated_patient = null;
                    }
                    this.confirm_info_loading = false;
                }
                return Promise.resolve(this.potential_duplicated_patient);
            }catch(err){
                console.log("getDuplicatedPatient error:", err);
                this.potential_duplicated_patient = null;
                this.confirm_info_loading = false;
                throw new Error('Failed to check duplicated patients.');
            }
        },
        async mergePatientIds(){
            console.log('call merge patient api...', this.patient_id, this.potential_duplicated_patient.patient_id); 
            try{
                const res = await coreServiceBaseURL.get('/patient/merge-patients', {
                    headers:{ 
                        Authorization: `Bearer ${localStorage.getItem('pnsToken')?localStorage.getItem('pnsToken'):this.token}`
                    },
                    params:{
                        primary_patient_id: this.potential_duplicated_patient.patient_id,
                        needToMerge_patient_id: this.patient_id,
                    }
                });
                console.log('merge patient successfully', res);
                //if merge success: show success notice and return true
                ElNotification({
                    title: 'Success',
                    customClass: 'successNotification',
                    message: `Successfully merge patient ${this.patient_id} into patient ${this.potential_duplicated_patient.patient_id}`,
                    type: 'success',
                    duration: 3500,
                });
                return Promise.resolve(true);
            }catch(err){
                console.log('/patient/merge-patients error: ', err);
                throw new Error('Failed to merge patients');
            }
        },
        extractChangedInputs(){
            //compare current_shipping_address_data and previous_shipping_address_data,
            // only extract changed fields 
            var output = {};
            for(const field in this.current_shipping_address_data){
                // the phone field's value has been converted from string into object, when get data from backend.
                // so need to check phone field's change via another logic.
                if(field == 'phone'){
                    const cur_phone = `+${this.current_shipping_address_data[field]['area_code']}-${this.current_shipping_address_data[field]['phone_number']}`;
                    const prev_phone = `+${this.previous_shipping_address_data[field]['area_code']}-${this.previous_shipping_address_data[field]['phone_number']}`;
                    // if the phone changed, convert phone object to string format
                    if(cur_phone != prev_phone){
                        output[field] = cur_phone;
                    }
                }else if(field == 'apt_po'){
                    // VIB-1775: /utility/confirmAddress tri-state for apt_po — absent = keep, "" = clear, value = overwrite.
                    // Only include it when the (trimmed) value actually differs from what is on file.
                    const cur_apt_po = (this.current_shipping_address_data[field] ?? '').trim();
                    const prev_apt_po = (this.previous_shipping_address_data[field] ?? '').trim();
                    if(cur_apt_po != prev_apt_po){
                        output[field] = cur_apt_po;
                    }
                }else if(this.current_shipping_address_data[field]!=this.previous_shipping_address_data[field]){
                    output[field] = this.current_shipping_address_data[field];
                }
            }
            return output;
        },
        detectGzNyAddressMismatch(){
            // VIB-1735 / PRD §4.1 & §4.2: detect when this address change flips the patient's
            // NY classification in a way that makes an existing Gut Zoomer / Gut Zoomer New York
            // order unshippable as-ordered. Returns { direction, patient_state } or null.
            const was_ny = isNewYorkState(this.previous_shipping_address_data?.state);
            const now_ny = isNewYorkState(this.current_shipping_address_data?.state);
            // Same-bucket edits (NY -> NY or non-NY -> non-NY) are always allowed.
            if(was_ny == now_ny){
                return null;
            }
            // §4.1: non-NY -> NY on a standard Gut Zoomer / Gut Zoomer - Stool Only order (tagged "GZ").
            if(!was_ny && now_ny && this.is_gz_order){
                return { direction: 'non_ny_to_ny', patient_state: getFullStateName(this.current_shipping_address_data?.state) };
            }
            // §4.2: NY -> non-NY on a Gut Zoomer New York order.
            if(was_ny && !now_ny && this.is_gz_ny_order){
                return { direction: 'ny_to_non_ny', patient_state: getFullStateName(this.current_shipping_address_data?.state) };
            }
            return null;
        },
        async confirmShippingAddress(){
            // VIB-1735 / PRD §4.1 & §4.2: block a post-checkout address change that would create a
            // GZ/GZ-NY mismatch on an existing order. The frontend blocks at source and never calls
            // /utility/confirmAddress, so the address is not persisted. The §10 email pair and its
            // (order, direction) dedup are handled entirely by backend (out of frontend scope).
            const gz_ny_mismatch = this.detectGzNyAddressMismatch();
            if(gz_ny_mismatch){
                console.log('VIB-1735 GZ/GZ-NY address-change mismatch blocked', gz_ny_mismatch);
                this.gz_ny_block_direction = gz_ny_mismatch.direction;
                this.gz_ny_block_patient_state = gz_ny_mismatch.patient_state;
                this.show_gz_ny_block_dialog = true;
                this.confirm_info_loading = false;
                return;
            }
            console.log('call /confirmAddress api...');
            this.confirm_info_loading = true;
            //need to check whether changes are significant before actually change the shipping address
            const is_address_change_significant = await this.checkWhetherAddressChangeIsSignificant();
            this.is_address_change_significant_before_confirmed = is_address_change_significant;
            //extract changed field as we only send change values to the backend.
            //NOTES: already convert "phone" back from object to string format
            var changeInputs = this.extractChangedInputs();
            console.log('confirmShippingAddress changedInputs', changeInputs);
            //if the user merged patient before, not send DOB, gender as its already the same in the backend
            //so delete DOB and gender
            if(this.merged_patient){
                delete changeInputs['birthdate'];
                delete changeInputs['gender'];
            }
            var params = {
                sample_id: this.sample_id,
                //changed inputs for shipping address and basic information
                ...changeInputs,
                //if is_current_shipping_address_same_with_patient_profile_address == true:
                //we won't use is_apply_to_future_order's value. Default treat it to be false;
                // is_address_applied_to_future: this.address_needed==false || this.is_current_shipping_address_same_with_patient_profile_address ? false : this.is_apply_to_future_order,
            };
            if(this.address_needed!=false){
                params['is_address_applied_to_future'] = this.is_current_shipping_address_same_with_patient_profile_address ? false : this.is_apply_to_future_order;
            }

            baseURL.post('/utility/confirmAddress',
                params,
                {
                    headers:{ 
                        Authorization: `Bearer ${this.token}`
                    },
                }
            ).then((res)=>{
                console.log('save shipping address', res.data.status_code);
                if(res.data.status_code == 200){
                    this.edits_saved = true;
                }else{
                    ElNotification({
                        title: 'Failed',
                        type: 'error',
                        customClass: "errorNotification",
                        message: 'Shipping Address Save Failed',
                        duration: 0,
                    });
                }
                this.confirm_info_loading = false;
            }).catch((err)=>{
                console.log('/confirmAddress api error:',err);
                this.confirm_info_loading = false;
            })
        },
        async checkWhetherAddressChangeIsSignificant(){
            // console.log('checkWhetherAddressChangeIsSignificant');
            try{
                // VIB-1775: LIS-Shipping treats an absent apt_po as "unchanged" and an explicit "" as "cleared",
                // so only send it when the trimmed unit actually differs from what is on file (same rule as extractChangedInputs()).
                const cur_apt_po = (this.current_shipping_address_data.apt_po ?? '').trim();
                const prev_apt_po = (this.previous_shipping_address_data.apt_po ?? '').trim();
                const response = await inventoryBaseURL.post('/orders/samples/shipping-address/changes/check',
                {
                    sample_id: this.sample_id,
                    street:this.current_shipping_address_data.street,
                    ...(cur_apt_po != prev_apt_po ? { apt_po: cur_apt_po } : {}),
                    city:this.current_shipping_address_data.city,
                    state:this.current_shipping_address_data.state,
                    zipcode:this.current_shipping_address_data.zipcode,
                    country:this.current_shipping_address_data.country,
                    name:this.current_shipping_address_data.name,   
                },
                {
                    headers:{ 
                        Authorization: `Bearer ${this.token}`
                    },
                });
                return response.data.data.address_verified_by_patient_samples;
            }catch(err){
                console.log('checkWhetherAddressChangeIsFake error', err);
                return true;
            }
        },
        updateEditsSaved(val){
            this.edits_saved = val;
        },
        closeGzNyBlockDialog(){
            // VIB-1735: dismiss the §4.x block popup. The address was never persisted.
            this.show_gz_ny_block_dialog = false;
        },
        updateCurrentShippingAddress(key, val){
            //if update key is country: only allow update when originally country value is empty
            if(key == 'country'){
                if(!this.previous_shipping_address_data['country']){
                    this.current_shipping_address_data[key] = val;
                }
            }else{
                this.current_shipping_address_data[key] = val;
            }
        },
        clearAddressFieldsOnCountryChange(){
            // VP-18349: clear every address component except country, name and phone.
            // Only keys that exist on the form data are touched, so a field that is not part of this form
            // is never added (and therefore never reported as a change by extractChangedInputs()).
            for(const field of ['street', 'apt_po', 'city', 'state', 'zipcode']){
                if(field in this.current_shipping_address_data){
                    this.current_shipping_address_data[field] = '';
                }
            }
        },
        addRequiredInputFields(val){
            if(!this.required_input_fields[val]){
                this.required_input_fields[val] = 1;
            }else{
                this.required_input_fields[val]++;
            }
        },
        removeRequiredInputFields(val){
            if(!this.required_input_fields[val] || this.required_input_fields[val]<=1){
                delete this.required_input_fields[val];
            }else{
                this.required_input_fields[val]--;
            }
        },
        handleAddInvalidInputValue(input_id, section){
        // section: ENUM -> 'basic_info_section', 'shipping_address_section'
            if(!this.invalid_input_values[section]){
                this.invalid_input_values[section] = {
                    [input_id]: true
                };
            }else{
                this.invalid_input_values[section][input_id] = true;
            }
        },
        handleRemoveInvalidInputValue(input_id, section){
        // section: ENUM -> 'basic_info_section', 'shipping_address_section' 
            if(this.invalid_input_values?.[section]?.[input_id]){
                delete this.invalid_input_values[section][input_id];
            }
        },  
        updateIsCurrentShippingAddressSameWithPatientProfileAddress(val){
            this.is_current_shipping_address_same_with_patient_profile_address = val;
        },
        updateShowContactSupportToSolveDuplicatedPatient(val){
            this.show_contact_support_to_solve_duplicated_patient = val;
        },
        updateMergedPatient(val){
            this.merged_patient = val;
        },
    }
})